import { render } from "./whatsapp.vue?vue&type=template&id=18c271f7&scoped=true"
import script from "./whatsapp.vue?vue&type=script&lang=js"
export * from "./whatsapp.vue?vue&type=script&lang=js"

import "./whatsapp.vue?vue&type=style&index=0&id=18c271f7&scoped=true&lang=css"
import "./whatsapp.vue?vue&type=style&index=1&id=18c271f7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c271f7"]])

export default __exports__